import axios from 'axios';

import type { Country, Covid19AckWrapper } from '@bb/domain/dist/types';

export type GetAckWrapperResponse = Covid19AckWrapper;

const getCovid19AckWrapper = async (country?: Country) => {
  const { data: covid19AckWrapper } = await axios.get<GetAckWrapperResponse>(
    `/covid19/ack/wrapper`,
    { params: { country } },
  );

  return covid19AckWrapper;
};

export default getCovid19AckWrapper;
